import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/proces-verificare-dealeri/")({
  head: () => routeHead("/proces-verificare-dealeri/"),
  beforeLoad: () => {
    throw redirect({ href: "/incredere/verificare-dealeri", statusCode: 301, replace: true });
  },
});
